/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-19 09:50:12
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-02-02 18:55:13
 */

// const url = process.env.BASE_URL

// const url = process.env.BASE_URL
import store from '@/store'
let config= {
  version: '1.0.0',
  ossDomain: process.env.VUE_APP_OSS_DOMAIN, // oss域名
  ossAppDir: 'xladmin', // oss目录
  uniBaseURL: process.env.VUE_APP_UNI_BASEURL, // html5链接
  pageSize: 10, // 分页条数
  tokenTime: 60 * 60 * 1000,
  loginAppId: '3c9a1563796c401183c6a441f5b96e1b',
  verificateAppId: 'fcc3fd8ddfb14cd68c54c0cc34f63bd6',
  // 多域名静态资源配置
  initDomain: {
    'default': {
      ename: "kuaihuolong",
      title: "快活龙",
      domain: "trade.51xinlong.com",
      logo: "/static/images/default/logo.png",
      logoTop: "",
      logoLogin: "/static/images/default/logo.png",
      backgroundImg: "/static/images/default/banner.jpg",
      icoUrl: "/static/images/default/default.ico",
      siderLogo: "/static/images/default/siderLogo.png",
      appQR: "/static/images/default/QRCode.jpg",
      location: '杭州',
      appId: '888', //正式888 请勿随意更改
      alipayAppId:'2000',//支付宝appid 测试2000 正式  请勿随意更改
      appIndividualId: '1002',
      settlmentlCustom: {
        companyIds: [148834054111420416],
        originName: ['江西省顺捷信息技术服务有限公司'],
        currentName: '芜湖创晖信息技术有限公司',
        paymentAccount: '34050167680800000599',
        bankOfDeposit: '中国建设银行股份有限公司芜湖弋江支行',
        taxRate: '6',
        placeholder: '***'
      },
      beianCode: '浙ICP备17050645号-1 浙公网安备33011002014843号'
    },
    'manage.test.51xinlong.com': {
      ename: "kuaihuolong-test",
      title: "快活龙",
      domain: "manage.test.51xinlong.com",
      logo: "/static/images/khl-test/logo.png",
      logoTop: "",
      logoLogin: "/static/images/khl-test/logo.png",
      backgroundImg: "/static/images/khl-test/banner.jpg",
      icoUrl: "/static/images/khl-test/default.ico",
      siderLogo: "/static/images/khl-test/siderLogo.png",
      appQR: "/static/images/khl-test/QRCode.jpg",
      location: '杭州',
      appId: '1004',
      appIndividualId: '1002',
      settlmentlCustom: {
        companyIds: [1],
        originName: ['*****服务公司'],
        currentName: '芜湖创晖信息技术有限公司',
        paymentAccount: '34050167680800000599',
        bankOfDeposit: '中国建设银行股份有限公司芜湖弋江支行',
        taxRate: '6',
        placeholder: '***'
      }
    },

    'www.xsb001.com': {
      ename: "xinshuibao",
      title: "薪税宝",
      domain: "www.xsb001.com",
      logo: "/static/images/xinshuibao/logo.png",
      logoTop: "/static/images/xinshuibao/logo-top.png",
      logoLogin: "/static/images/xinshuibao/logo.png",
      backgroundImg: "/static/images/xinshuibao/banner.jpg",
      icoUrl: "/static/images/xinshuibao/default.ico",
      siderLogo: "/static/images/xinshuibao/siderLogo.png",
      beianCode: '浙ICP备20027011号-1'
    },
    'www.hzdongxin.cn': {
      ename: "dongxin",
      title: "东薪网络",
      domain: "www.hzdongxin.cn",
      logo: "/static/images/dongxinwangluo/logo.png",
      logoTop: "/static/images/dongxinwangluo/logo-top.png",
      logoLogin: "/static/images/dongxinwangluo/logo.png",
      backgroundImg: "/static/images/dongxinwangluo/banner.jpg",
      icoUrl: "/static/images/dongxinwangluo/default.ico",
      siderLogo: "/static/images/dongxinwangluo/siderLogo.png"
    },
    'test.hzdongxin.cn': {
      ename: "dongxin",
      title: "东薪网络",
      domain: "test.hzdongxin.cn",
      logo: "/static/images/dongxinwangluo/logo.png",
      logoTop: "/static/images/dongxinwangluo/logo-top.png",
      logoLogin: "/static/images/dongxinwangluo/logo.png",
      backgroundImg: "/static/images/dongxinwangluo/banner.jpg",
      icoUrl: "/static/images/dongxinwangluo/default.ico",
      siderLogo: "/static/images/dongxinwangluo/siderLogo.png"
    },
    'khl-dongxin.51xinlong.com': {
      ename: "dongxin",
      title: "东薪网络",
      domain: "khl-dongxin.51xinlong.com",
      logo: "/static/images/dongxinwangluo/logo.png",
      logoTop: "/static/images/dongxinwangluo/logo-top.png",
      logoLogin: "/static/images/dongxinwangluo/logo.png",
      backgroundImg: "/static/images/dongxinwangluo/banner.jpg",
      icoUrl: "/static/images/dongxinwangluo/default.ico",
      siderLogo: "/static/images/dongxinwangluo/siderLogo.png"
    },
    'kst-dongxin.51xinlong.com': {
      ename: "dongxin",
      title: "东薪网络",
      domain: "kst-dongxin.51xinlong.com",
      logo: "/static/images/dongxinwangluo/logo.png",
      logoTop: "/static/images/dongxinwangluo/logo-top.png",
      logoLogin: "/static/images/dongxinwangluo/logo.png",
      backgroundImg: "/static/images/dongxinwangluo/banner.jpg",
      icoUrl: "/static/images/dongxinwangluo/default.ico",
      siderLogo: "/static/images/dongxinwangluo/siderLogo.png"
    },   
    'kst-haobo.51xinlong.com': {
      ename: "haoborenli",
      title: "皓博人力",
      domain: "kst-haobo.51xinlong.com",
      logo: "/static/images/haoborenli/logo.png",
      logoTop: "",
      logoLogin: "/static/images/haoborenli/logo.png",
      backgroundImg: "/static/images/haoborenli/banner.jpg",
      icoUrl: "/static/images/haoborenli/default.ico",
      siderLogo: "/static/images/haoborenli/siderLogo.png"
    },
    'khl-haobo.51xinlong.com': {
      ename: "haoborenli",
      title: "皓博人力",
      domain: "khl-haobo.51xinlong.com",
      logo: "/static/images/haoborenli/logo.png",
      logoTop: "",
      logoLogin: "/static/images/haoborenli/logo.png",
      backgroundImg: "/static/images/haoborenli/banner.jpg",
      icoUrl: "/static/images/haoborenli/default.ico",
      siderLogo: "/static/images/haoborenli/siderLogo.png"
    },
    'xin.hzqfyx.com': {
      ename: "hzqfyx",
      title: "企服优选",
      domain: "xin.hzqfyx.com",
      logo: "/static/images/qifuyouxuan/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qifuyouxuan/logo.png",
      backgroundImg: "/static/images/qifuyouxuan/banner.jpg",
      icoUrl: "/static/images/qifuyouxuan/default.ico",
      siderLogo: "/static/images/qifuyouxuan/siderLogo.png"
    },
    // 'khl-whch.51xinlong.com': {
    //   ename: "whch",
    //   title: "芜湖创晖",
    //   domain: "khl-whch.51xinlong.com",
    //   logo: "/static/images/whch/logo.png",
    //   logoTop: "",
    //   logoLogin: "/static/images/default/logo.png",
    //   backgroundImg: "/static/images/default/banner.jpg",
    //   icoUrl: "/static/images/default/default.ico",
    //   siderLogo: "/static/images/default/siderLogo.png"
    // },
    'khl-whch.51xinlong.com': {
      ename: "whch",
      title: "芜湖创晖",
      domain: "khl-whch.51xinlong.com",
      logo: "/static/images/whch/logo.jpg",
      logoTop: "",
      logoLogin: "/static/images/whch/logo.jpg",
      backgroundImg: "/static/images/whch/banner.jpg",
      icoUrl: "/static/images/whch/defualt.ico",
      siderLogo: "/static/images/whch/siderLogo.jpg"
    },
    'ry.hzqfyx.com': {
      ename: "hzqfyx",
      title: "睿赢企服",
      domain: "ry.hzqfyx.com",
      logo: "/static/images/ruiying/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ruiying/logo.png",
      backgroundImg: "/static/images/ruiying/banner.jpg",
      icoUrl: "/static/images/ruiying/default.ico",
      siderLogo: "/static/images/ruiying/siderLogo.png"
    },
    'khl-kdw.51xinlong.com': {
      ename: "tyqf",
      title: "腾云企服",
      domain: "khl-kdw.51xinlong.com",
      logo: "/static/images/kdw/logo.png",
      logoTop: "",
      logoLogin: "/static/images/kdw/logo.png",
      backgroundImg: "/static/images/kdw/banner.jpg",
      icoUrl: "/static/images/kdw/default.ico",
      siderLogo: "/static/images/kdw/siderLogo.png"
    },
    'lhyg.51koudaiwang.com': {
      ename: "tyqf",
      title: "腾云企服",
      domain: "lhyg.51koudaiwang.com",
      logo: "/static/images/kdw/logo.png",
      logoTop: "",
      logoLogin: "/static/images/kdw/logo.png",
      backgroundImg: "/static/images/kdw/banner.jpg",
      icoUrl: "/static/images/kdw/default.ico",
      siderLogo: "/static/images/kdw/siderLogo.png"
    },
    'khl-ym.51xinlong.com': {
      ename: "yunmi",
      title: "云米",
      domain: "khl-ym.51xinlong.com",
      logo: "/static/images/ym/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ym/logo.png",
      backgroundImg: "/static/images/ym/banner.jpg",
      icoUrl: "/static/images/ym/default.ico",
      siderLogo: "/static/images/ym/siderLogo.png"
    },
    'khl-ml.51xinlong.com': {
      ename: "ml",
      title: "木链",
      domain: "khl-ml.51xinlong.com",
      logo: "/static/images/ml/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ml/logo.png",
      backgroundImg: "/static/images/ml/banner.jpg",
      icoUrl: "/static/images/ml/default.ico",
      siderLogo: "/static/images/ml/siderLogo.png"
    },
    'khl-szy.51xinlong.com': {
      ename: "shangzhuangyuan",
      title: "商状元",
      domain: "khl-szy.51xinlong.com/",
      logo: "/static/images/szy/logo.png",
      logoTop: "",
      logoLogin: "/static/images/szy/logo.png",
      backgroundImg: "/static/images/szy/banner.jpg",
      icoUrl: "/static/images/szy/default.ico",
      siderLogo: "/static/images/szy/siderLogo.png"
    },
    'khl-jc.51xinlong.com': {
      ename: "jici",
      title: "济慈",
      domain: "khl-jc.51xinlong.com",
      logo: "/static/images/jc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jc/logo.png",
      backgroundImg: "/static/images/jc/banner.jpg",
      icoUrl: "/static/images/jc/default.ico",
      siderLogo: "/static/images/jc/siderLogo.png"
    },
    'khl-yxcs.51xinlong.com': {
      ename: "yixiaocaishui",
      title: "易晓财税",
      domain: "khl-yxcs.51xinlong.com",
      logo: "/static/images/yxcs/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yxcs/logo.png",
      backgroundImg: "/static/images/yxcs/banner.jpg",
      icoUrl: "/static/images/yxcs/default.ico",
      siderLogo: "/static/images/yxcs/siderLogo.png"
    },
    'khl-yx.51xinlong.com': {
      ename: "yaxuan",
      title: "雅轩文化传媒",
      domain: "khl-yx.51xinlong.com",
      logo: "/static/images/yx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yx/logo.png",
      backgroundImg: "/static/images/yx/banner.jpg",
      icoUrl: "/static/images/yx/default.ico",
      siderLogo: "/static/images/yx/siderLogo.png"
    },
    'khl-sxyl.51xinlong.com': {
      ename: "shengxuanyule",
      title: "笙轩娱乐",
      domain: "khl-sxyl.51xinlong.com",
      logo: "/static/images/sxyl/logo.png",
      logoTop: "",
      logoLogin: "/static/images/sxyl/logo.png",
      backgroundImg: "/static/images/sxyl/banner.jpg",
      icoUrl: "/static/images/sxyl/default.ico",
      siderLogo: "/static/images/sxyl/siderLogo.png"
    },
    'hzchs.hzjaxxkj.com': {
      ename: "anjicaihe",
      title: "安吉财合",
      domain: "hzchs.hzjaxxkj.com",
      logo: "/static/images/ajch/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ajch/logo.png",
      backgroundImg: "/static/images/ajch/banner.jpg",
      icoUrl: "/static/images/ajch/default1.ico",
      siderLogo: "/static/images/ajch/siderLogo.png"
    },
    'khl-xlc.51xinlong.com': {
      ename: "xinlingcai",
      title: "薪灵才",
      domain: "khl-xlc.51xinlong.com",
      logo: "/static/images/xlc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xlc/logo.png",
      backgroundImg: "/static/images/xlc/banner.jpg",
      icoUrl: "/static/images/xlc/default2.ico",
      siderLogo: "/static/images/xlc/siderLogo.png"
    },
    'khl-oem.51xinlong.com': {
      ename: "nologo",
      title: "",
      domain: "khl-oem.51xinlong.com",
      logo: "/static/images/nologo/logo.png",
      logoTop: "",
      logoLogin: "/static/images/nologo/logo.png",
      backgroundImg: "/static/images/nologo/banner.jpg",
      icoUrl: "/static/images/nologo/default.ico",
      siderLogo: "/static/images/nologo/siderLogo.png"
    },
    'kst-oem.51xinlong.com': {
      ename: "nologo",
      title: "",
      domain: "kst-oem.51xinlong.com",
      logo: "/static/images/nologo/logo.png",
      logoTop: "",
      logoLogin: "/static/images/nologo/logo.png",
      backgroundImg: "/static/images/nologo/banner.jpg",
      icoUrl: "/static/images/nologo/default.ico",
      siderLogo: "/static/images/nologo/siderLogo.png"
    },
    'khl-ys.51xinlong.com': {
      ename: "yunshang",
      title: "云尚",
      domain: "khl-ys.51xinlong.com",
      logo: "/static/images/ys/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ys/logo.png",
      backgroundImg: "/static/images/ys/banner.jpg",
      icoUrl: "/static/images/ys/default.ico",
      siderLogo: "/static/images/ys/siderLogo.png"
    },
    'khl-cc.51xinlong.com': {
      ename: "chuncheng",
      title: "春城科技",
      domain: "khl-cc.51xinlong.com",
      logo: "/static/images/cc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/cc/logo.png",
      backgroundImg: "/static/images/cc/banner.jpg",
      icoUrl: "/static/images/cc/default.ico",
      siderLogo: "/static/images/cc/siderLogo.png"
    },
    'khl-xcwh.51xinlong.com': {
      ename: "xinchuangwenhua",
      title: "星创文化",
      domain: "khl-xcwh.51xinlong.com",
      logo: "/static/images/xcwh/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xcwh/logo.png",
      backgroundImg: "/static/images/xcwh/banner.jpg",
      icoUrl: "/static/images/xcwh/default.ico",
      siderLogo: "/static/images/xcwh/siderLogo.png"
    },
    'khl-qdh.51xinlong.com': {
      ename: "yundiangong",
      title: "云点工",
      domain: "khl-qdh.51xinlong.com",
      logo: "/static/images/qdh/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qdh/logo.png",
      backgroundImg: "/static/images/qdh/banner.jpg",
      icoUrl: "/static/images/qdh/default.ico",
      siderLogo: "/static/images/qdh/siderLogo.png"
    },
    'khl-zqzx.51xinlong.com': {
      ename: "zhaoqingzhongxin",
      title: "肇庆众信",
      domain: "khl-zqzx.51xinlong.com",
      logo: "/static/images/zqzx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zqzx/logo.png",
      backgroundImg: "/static/images/zqzx/banner.jpg",
      icoUrl: "/static/images/zqzx/default1.ico",
      siderLogo: "/static/images/zqzx/siderLogo.png"
    },
    'saas.gaolanshw.com': {
      ename: "gaolanzixun",
      title: "高蓝咨询",
      domain: "saas.gaolanshw.com",
      logo: "/static/images/glzx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/glzx/logo.png",
      backgroundImg: "/static/images/glzx/banner.jpg",
      icoUrl: "/static/images/glzx/default1.ico",
      siderLogo: "/static/images/glzx/siderLogo.png"
    },
    'khl-yqxf.51xinlong.com': {
      ename: "yiqixinfu",
      title: "亿企新服",
      domain: "khl-yqxf.51xinlong.com",
      logo: "/static/images/yqxf/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yqxf/logo.png",
      backgroundImg: "/static/images/yqxf/banner.jpg",
      icoUrl: "/static/images/yqxf/default.ico",
      siderLogo: "/static/images/yqxf/siderLogo.png"
    },
    'khl-sqq.51xinlong.com': {
      ename: "shuiqingqing",
      title: "税轻轻",
      domain: "khl-sqq.51xinlong.com",
      logo: "/static/images/sqq/logo.png",
      logoTop: "",
      logoLogin: "/static/images/sqq/logo.png",
      backgroundImg: "/static/images/sqq/banner.jpg",
      icoUrl: "/static/images/sqq/default.ico",
      siderLogo: "/static/images/sqq/siderLogo.png"
    },
    'khl-yst.51xinlong.com': {
      ename: "yueshuitongtianxia",
      title: "粤税通天下",
      domain: "khl-yst.51xinlong.com",
      logo: "/static/images/ysttx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ysttx/logo.png",
      backgroundImg: "/static/images/ysttx/banner.jpg",
      icoUrl: "/static/images/ysttx/default.ico",
      siderLogo: "/static/images/ysttx/siderLogo.png"
    },
    'khl-ttrl.51xinlong.com': {
      ename: "tiantianyonggong",
      title: "天天用工",
      domain: "khl-ttrl.51xinlong.com",
      logo: "/static/images/ttyg/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ttyg/logo.png",
      backgroundImg: "/static/images/ttyg/banner.jpg",
      icoUrl: "/static/images/ttyg/default.ico",
      siderLogo: "/static/images/ttyg/siderLogo.png"
    },
    'khl-jcyz.51xinlong.com': {
      ename: "jincaiyunzhi",
      title: "金财云智",
      domain: "khl-jcyz.51xinlong.com",
      logo: "/static/images/jcyz/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jcyz/logo.png",
      backgroundImg: "/static/images/jcyz/banner.jpg",
      icoUrl: "/static/images/jcyz/default.ico",
      siderLogo: "/static/images/jcyz/siderLogo.png"
    },
    'saas.qiaoduogong.com': {
      ename: "qiaoduogong",
      title: "巧多工",
      domain: "saas.qiaoduogong.com",
      logo: "/static/images/qdg/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qdg/logo.png",
      backgroundImg: "/static/images/qdg/banner.jpg",
      icoUrl: "/static/images/qdg/default.ico",
      siderLogo: "/static/images/qdg/siderLogo.png"
    },
    'khl-qc.51xinlong.com': {
      ename: "qichen",
      title: "企臣",
      domain: "khl-qc.51xinlong.com",
      logo: "/static/images/qc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qc/logo.png",
      backgroundImg: "/static/images/qc/banner.jpg",
      icoUrl: "/static/images/qc/default.ico",
      siderLogo: "/static/images/qc/siderLogo.png"
    },
    'khl-zlr.51xinlong.com': {
      ename: "zhuluren",
      title: "逐鹿人",
      domain: "khl-zlr.51xinlong.com",
      logo: "/static/images/zlr/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zlr/logo.png",
      backgroundImg: "/static/images/zlr/banner.jpg",
      icoUrl: "/static/images/zlr/default.ico",
      siderLogo: "/static/images/zlr/siderLogo.png"
    },
    'khl-xx.51xinlong.com': {
      ename: "xinxin",
      title: "薪鑫",
      domain: "khl-xx.51xinlong.com",
      logo: "/static/images/xx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xx/logo.png",
      backgroundImg: "/static/images/xx/banner.jpg",
      icoUrl: "/static/images/xx/default.ico",
      siderLogo: "/static/images/xx/siderLogo.png"
    },
    'khl-xhh.51xinlong.com': {
      ename: "xinhehuo",
      title: "薪合伙",
      domain: "khl-xhh.51xinlong.com",
      logo: "/static/images/xhh/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xhh/logo.png",
      backgroundImg: "/static/images/xhh/banner.jpg",
      icoUrl: "/static/images/xhh/default.ico",
      siderLogo: "/static/images/xhh/siderLogo.png",
      appId: '10002',
    },
    'khl-jjkj.51xinlong.com': {
      ename: "jijiakeji",
      title: "济嘉科技",
      domain: "khl-jjkj.51xinlong.com",
      logo: "/static/images/jj/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jj/logo.png",
      backgroundImg: "/static/images/jj/banner.jpg",
      icoUrl: "/static/images/jj/default.ico",
      siderLogo: "/static/images/jj/siderLogo.png"
    },
    'khl-sjyg.51xinlong.com': {
      ename: "shengji",
      title: "盛京用工",
      domain: "khl-sjyg.51xinlong.com",
      logo: "/static/images/sjyg/logo.png",
      logoTop: "",
      logoLogin: "/static/images/sjyg/logo.png",
      backgroundImg: "/static/images/sjyg/banner.jpg",
      icoUrl: "/static/images/sjyg/default.ico",
      siderLogo: "/static/images/sjyg/siderLogo.png"
    },
    'khl-szslb.51xinlong.com': {
      ename: "shenzhoushunli",
      title: "神州顺利办",
      domain: "khl-szslb.51xinlong.com",
      logo: "/static/images/szslb/logo.png",
      logoTop: "",
      logoLogin: "/static/images/szslb/logo.png",
      backgroundImg: "/static/images/szslb/banner.jpg",
      icoUrl: "/static/images/szslb/default.ico",
      siderLogo: "/static/images/szslb/siderLogo.png"
    },
    'khl-qcrl.51xinlong.com': {
      ename: "qingchengrenli",
      title: "青橙人力",
      domain: "khl-qcrl.51xinlong.com",
      logo: "/static/images/qcrl/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qcrl/logo.png",
      backgroundImg: "/static/images/qcrl/banner.jpg",
      icoUrl: "/static/images/qcrl/default.ico",
      siderLogo: "/static/images/qcrl/siderLogo.png"
    },
    'sharedworker.gzhsl.com.cn': {
      ename: "haishelianlaowu",
      title: "海社联劳务",
      domain: "sharedworker.gzhsl.com.cn",
      logo: "/static/images/hsllw/logo.png",
      logoTop: "",
      logoLogin: "/static/images/hsllw/logo.png",
      backgroundImg: "/static/images/hsllw/banner.jpg",
      icoUrl: "/static/images/hsllw/default.ico",
      siderLogo: "/static/images/hsllw/siderLogo.png"
    },
    'khl-trrc.51xinlong.com': {
      ename: "tianruirongchuang",
      title: "天瑞蓉创",
      domain: "khl-trrc.51xinlong.com",
      logo: "/static/images/trrc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/trrc/logo.png",
      backgroundImg: "/static/images/trrc/banner.jpg",
      icoUrl: "/static/images/trrc/default.ico",
      siderLogo: "/static/images/trrc/siderLogo.png"
    },
    'khl-mdker.51xinlong.com': {
      ename: "maidakeer",
      title: "麦达可尔",
      domain: "khl-mdker.51xinlong.com",
      logo: "/static/images/mdkr/logo.png",
      logoTop: "",
      logoLogin: "/static/images/mdkr/logo.png",
      backgroundImg: "/static/images/mdkr/banner.jpg",
      icoUrl: "/static/images/mdkr/default.ico",
      siderLogo: "/static/images/mdkr/siderLogo.png"
    },
    'business.salaryway.cn': {
      ename: "xinfutong",
      title: "薪付通",
      domain: "business.salaryway.cn",
      logo: "/static/images/xft/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xft/logo.png",
      backgroundImg: "/static/images/xft/banner.jpg",
      icoUrl: "/static/images/xft/default.ico",
      siderLogo: "/static/images/xft/siderLogo.png"
    },
    'khl-kpnrl.51xinlong.com': {
      ename: "kunningpengrenliziyuan",
      title: "鲲宁鹏人力资源",
      domain: "khl-kpnrl.51xinlong.com",
      logo: "/static/images/knprlzy/logo.png",
      logoTop: "",
      logoLogin: "/static/images/knprlzy/logo.png",
      backgroundImg: "/static/images/knprlzy/banner.jpg",
      icoUrl: "/static/images/knprlzy/default.ico",
      siderLogo: "/static/images/knprlzy/siderLogo.png"
    },
    'saas.renci.net': {
      ename: "renci",
      title: "仁慈",
      domain: "saas.renci.net",
      logo: "/static/images/rc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/rc/logo.png",
      backgroundImg: "/static/images/rc/banner.jpg",
      icoUrl: "/static/images/rc/default.ico",
      siderLogo: "/static/images/rc/siderLogo.png"
    },
    'zyp.wecloudhro.51xinlong.com': {
      ename: "zhiyepai",
      title: "职业派",
      domain: "zyp.wecloudhro.51xinlong.com",
      logo: "/static/images/zyp/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zyp/logo.png",
      backgroundImg: "/static/images/zyp/banner.jpg",
      icoUrl: "/static/images/zyp/default.ico",
      siderLogo: "/static/images/zyp/siderLogo.png"
    },
    'renliyun.renlidashuju.com': {
      ename: "renlidashuju",
      title: "人力云",
      domain: "renliyun.renlidashuju.com",
      logo: "/static/images/rly/logo.png",
      logoTop: "",
      logoLogin: "/static/images/rly/logo.png",
      backgroundImg: "/static/images/rly/banner.jpg",
      icoUrl: "/static/images/rly/default.ico",
      siderLogo: "/static/images/rly/siderLogo.png"
    },
    'khl-qdr.51xinlong.com': {
      ename: "qidaren",
      title: "企达人",
      domain: "khl-qdr.51xinlong.com",
      logo: "/static/images/qdr/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qdr/logo.png",
      backgroundImg: "/static/images/qdr/banner.jpg",
      icoUrl: "/static/images/qdr/default.ico",
      siderLogo: "/static/images/qdr/siderLogo.png"
    },
    'khl-nc.51xinlong.com': {
      ename: "nacairenliziyuan",
      title: "纳才人力资源",
      domain: "khl-nc.51xinlong.com",
      logo: "/static/images/nc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/nc/logo.png",
      backgroundImg: "/static/images/nc/banner.jpg",
      icoUrl: "/static/images/nc/default.ico",
      siderLogo: "/static/images/nc/siderLogo.png"
    },
    'khl-xly.51xinlong.com': {
      ename: "xinliaoyuan",
      title: "薪燎原",
      domain: "khl-xly.51xinlong.com",
      logo: "/static/images/xly/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xly/logo.png",
      backgroundImg: "/static/images/xly/banner.jpg",
      icoUrl: "/static/images/xly/default.ico",
      siderLogo: "/static/images/xly/siderLogo.png"
    },
    'khl-cny.51xinlong.com': {
      ename: "chengnayun",
      title: "诚纳云",
      domain: "khl-cny.51xinlong.com",
      logo: "/static/images/cny/logo.png",
      logoTop: "",
      logoLogin: "/static/images/cny/logo.png",
      backgroundImg: "/static/images/cny/banner.jpg",
      icoUrl: "/static/images/cny/default.ico",
      siderLogo: "/static/images/cny/siderLogo.png"
    },
    'e-ticket.eboss007.com': {
      ename: "piaoliankeji",
      title: "票联科技",
      domain: "e-ticket.eboss007.com",
      logo: "/static/images/plkj/logo.png",
      logoTop: "",
      logoLogin: "/static/images/plkj/logo.png",
      backgroundImg: "/static/images/plkj/banner.jpg",
      icoUrl: "/static/images/plkj/default.ico",
      siderLogo: "/static/images/plkj/siderLogo.png"
    },
    'khl-ymy.51xinlong.com': {
      ename: "yunmayi",
      title: "云蚂蚁",
      domain: "khl-ymy.51xinlong.com",
      logo: "/static/images/ymy/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ymy/logo.png",
      backgroundImg: "/static/images/ymy/banner.jpg",
      icoUrl: "/static/images/ymy/default.ico",
      siderLogo: "/static/images/ymy/siderLogo.png"
    },
    'khl-chkj.51xinlong.com': {
      ename: "canghaikeji",
      title: "沧海科技",
      domain: "khl-chkj.51xinlong.com",
      logo: "/static/images/canghaikeji/logo.png",
      logoTop: "",
      logoLogin: "/static/images/canghaikeji/logo.png",
      backgroundImg: "/static/images/canghaikeji/banner.jpg",
      icoUrl: "/static/images/canghaikeji/default.ico",
      siderLogo: "/static/images/canghaikeji/siderLogo.png"
    },
    'khl-ztjc.51xinlong.com': {
      ename: "zhongtongjiance",
      title: "中通检测",
      domain: "khl-ztjc.51xinlong.com",
      logo: "/static/images/ztjc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ztjc/logo.png",
      backgroundImg: "/static/images/ztjc/banner.jpg",
      icoUrl: "/static/images/ztjc/default.ico",
      siderLogo: "/static/images/ztjc/siderLogo.png"
    },
    'khl-hst.51xinlong.com': {
      ename: "huishitong",
      title: "惠事通",
      domain: "khl-hst.51xinlong.com",
      logo: "/static/images/huishitong/logo.png",
      logoTop: "",
      logoLogin: "/static/images/huishitong/logo.png",
      backgroundImg: "/static/images/huishitong/banner.jpg",
      icoUrl: "/static/images/huishitong/default.ico",
      siderLogo: "/static/images/huishitong/siderLogo.png"
    },
    'kst-csy.51xinlong.com': {
      ename: "caishuiyi",
      title: "财税益",
      domain: "http://kst-csy.51xinlong.com",
      logo: "/static/images/caishuiyi/logo.png",
      logoTop: "",
      logoLogin: "/static/images/caishuiyi/logo.png",
      backgroundImg: "/static/images/huishitong/banner.jpg",
      icoUrl: "/static/images/caishuiyi/default.ico",
      siderLogo: "/static/images/caishuiyi/siderLogo.png"
    },
    'khl-ycc.51xinlong.com': {
      ename: "yunchengcai",
      title: "云诚才",
      domain: "khl-ycc.51xinlong.com",
      logo: "/static/images/devyunchengcai/logo.png",
      logoTop: "",
      logoLogin: "/static/images/devyunchengcai/logo.png",
      backgroundImg: "/static/images/devyunchengcai/banner.jpg",
      icoUrl: "/static/images/devyunchengcai/default.ico",
      siderLogo: "/static/images/devyunchengcai/siderLogo.png"
    },
    'khl-dcx.51xinlong.com': {
      ename: "decaixin",
      title: "德财鑫",
      domain: "khl-dcx.51xinlong.com",
      logo: "/static/images/decaixing/logo.png",
      logoTop: "",
      logoLogin: "/static/images/decaixing/logo.png",
      backgroundImg: "/static/images/decaixing/banner.jpg",
      icoUrl: "/static/images/decaixing/default.ico",
      siderLogo: "/static/images/decaixing/siderLogo.png"
    },
    'khl-bc.51xinlong.com': {
      ename: "bocai",
      title: "博才",
      domain: "khl-bc.51xinlong.com",
      logo: "/static/images/bocai/logo.png",
      logoTop: "",
      logoLogin: "/static/images/bocai/logo.png",
      backgroundImg: "/static/images/bocai/banner.jpg",
      icoUrl: "/static/images/bocai/default.ico",
      siderLogo: "/static/images/bocai/siderLogo.png"
    },
    'saas.ylg123.cn': {
      ename: "shanqing",
      title: "山庆",
      domain: "saas.ylg123.cn",
      logo: "/static/images/szx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/szx/logo.png",
      backgroundImg: "/static/images/sqxxkj/banner.jpg",
      icoUrl: "/static/images/sqxxkj/default.ico",
      siderLogo: "/static/images/szx/siderLogo.png"
    },
    'khl-sry.51xinlong.com': {
      ename: "shangrenyuan",
      title: "上人院",
      domain: "khl-sry.51xinlong.com",
      logo: "/static/images/shangrenyuan/logo.png",
      logoTop: "",
      logoLogin: "/static/images/shangrenyuan/logo.png",
      backgroundImg: "/static/images/shangrenyuan/banner.jpg",
      icoUrl: "/static/images/shangrenyuan/default.ico",
      siderLogo: "/static/images/shangrenyuan/siderLogo.png"
    },
    'lrkj.lirenkeji.top': {
      ename: "lirenkeji",
      title: "里仁科技",
      domain: "lrkj.lirenkeji.top",
      logo: "/static/images/lirenkeji/logo.png",
      logoTop: "",
      logoLogin: "/static/images/lirenkeji/logo.png",
      backgroundImg: "/static/images/lirenkeji/banner.jpg",
      icoUrl: "/static/images/lirenkeji/default.ico",
      siderLogo: "/static/images/lirenkeji/siderLogo.png"
    },
    'def.yuntouck.com': {
      ename: "jiangxiyuntou",
      title: "江西云投",
      domain: "def.yuntouck.com",
      logo: "/static/images/jiangxiyuntou/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jiangxiyuntou/logo.png",
      backgroundImg: "/static/images/jiangxiyuntou/banner.jpg",
      icoUrl: "/static/images/jiangxiyuntou/default.ico",
      siderLogo: "/static/images/jiangxiyuntou/siderLogo.png"
    },
    'khl-qsb.51xinlong.com': {
      ename: "qingshuibao",
      title: "轻税宝",
      domain: "khl-qsb.51xinlong.com",
      logo: "/static/images/qingshuibao/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qingshuibao/logo.png",
      backgroundImg: "/static/images/qingshuibao/banner.jpg",
      icoUrl: "/static/images/qingshuibao/default.ico",
      siderLogo: "/static/images/qingshuibao/siderLogo.png"
    },
    'khl-sprl.51xinlong.com': {
      ename: "sanpengrenli",
      title: "三朋人力",
      domain: "khl-sprl.51xinlong.com",
      logo: "/static/images/sanpengrenli/logo.png",
      logoTop: "",
      logoLogin: "/static/images/sanpengrenli/logo.png",
      backgroundImg: "/static/images/sanpengrenli/banner.jpg",
      icoUrl: "/static/images/sanpengrenli/default.ico",
      siderLogo: "/static/images/sanpengrenli/siderLogo.png"
    },
    'saas.hengexin.cn': {
      ename: "yixinyun",
      title: "益薪云",
      domain: "saas.hengexin.cn",
      logo: "/static/images/yixinyun/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yixinyun/logo.png",
      backgroundImg: "/static/images/yixinyun/banner.jpg",
      icoUrl: "/static/images/yixinyun/default.ico",
      siderLogo: "/static/images/yixinyun/siderLogo.png",
      beianCode: '京ICP备2021023889号-1'
    },
    'bdqe.triopen.com': {
      ename: "beidouqie",
      title: "北斗企鹅",
      domain: "bdqe.triopen.com",
      logo: "/static/images/beidouqie/logo.png",
      logoTop: "",
      logoLogin: "/static/images/beidouqie/logo.png",
      backgroundImg: "/static/images/beidouqie/banner.jpg",
      icoUrl: "/static/images/beidouqie/default.ico",
      siderLogo: "/static/images/beidouqie/siderLogo.png"
    },
   'khl-sg.51xinlong.com': {
      ename: "shanggao",
      title: "尚高",
      domain: "khl-sg.51xinlong.com",
      logo: "/static/images/shanggao/logo.png",
      logoTop: "",
      logoLogin: "/static/images/shanggao/logo.png",
      backgroundImg: "/static/images/shanggao/banner.jpg",
      icoUrl: "/static/images/shanggao/default.ico",
      siderLogo: "/static/images/shanggao/siderLogo.png"
    },
    'manage-xnf.xinnafu.com': {
      ename: "xinnafu",
      title: "鑫纳服",
      domain: "manage-xnf.xinnafu.com",
      logo: "/static/images/xinnafu/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xinnafu/logo.png",
      backgroundImg: "/static/images/xinnafu/banner.jpg",
      icoUrl: "/static/images/xinnafu/default.ico",
      siderLogo: "/static/images/xinnafu/siderLogo.png"
    },
    'khl-zhl.51xinlong.com': {
      ename: "zhonghengli",
      title: "众恒力",
      domain: "khl-zhl.51xinlong.com",
      logo: "/static/images/zhonghengli/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zhonghengli/logo.png",
      backgroundImg: "/static/images/xinnafu/banner.jpg",
      icoUrl: "/static/images/zhonghengli/default.ico",
      siderLogo: "/static/images/zhonghengli/siderLogo.png"
    },
    'khl-zj.51xinlong.com': {
      ename: "zhejia",
      title: "这佳集团",
      domain: "khl-zj.51xinlong.com",
      logo: "/static/images/zhejia/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zhejia/logo.png",
      backgroundImg: "/static/images/zhejia/banner.jpg",
      icoUrl: "/static/images/zhejia/default.ico",
      siderLogo: "/static/images/zhejia/siderLogo.png"
    },
    'saas.meichai.in': {
      ename: "meichai",
      title: "美差",
      domain: "saas.meichai.in",
      logo: "/static/images/meichai/logo.png",
      logoTop: "",
      logoLogin: "/static/images/meichai/logo.png",
      backgroundImg: "/static/images/meichai/banner.jpg",
      icoUrl: "/static/images/meichai/default.ico",
      siderLogo: "/static/images/meichai/siderLogo.png"
    },
    'khl-jindou.51xinlong.com': {
      ename: "jindouyun",
      title: "金斗云",
      domain: "khl-jindou.51xinlong.com",
      logo: "/static/images/jindouyun/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jindouyun/logo.png",
      backgroundImg: "/static/images/jindouyun/banner.jpg",
      icoUrl: "/static/images/jindouyun/default.ico",
      siderLogo: "/static/images/jindouyun/siderLogo.png"
    },
    'khl-gbb.51xinlong.com': {
      ename: "gongbangbang",
      title: "工帮帮",
      domain: "khl-gbb.51xinlong.com",
      logo: "/static/images/gongbang/logo.png",
      logoTop: "",
      logoLogin: "/static/images/gongbang/logo.png",
      backgroundImg: "/static/images/gongbang/banner.jpg",
      icoUrl: "/static/images/gongbang/default.ico",
      siderLogo: "/static/images/gongbang/siderLogo.png"
    },
    'khl-qisb.51xinlong.com': {
      ename: "qishuibao",
      title: "企税宝",
      domain: "khl-qisb.51xinlong.com",
      logo: "/static/images/qishuibao/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qishuibao/logo.png",
      backgroundImg: "/static/images/qishuibao/banner.jpg",
      icoUrl: "/static/images/qishuibao/default.ico",
      siderLogo: "/static/images/qishuibao/siderLogo.png"
    },
    'khl-nrj.51xinlong.com': {
      ename: "nengrenjie",
      title: "能人接",
      domain: "khl-nrj.51xinlong.com",
      logo: "/static/images/nengrenjie/logo.png",
      logoTop: "",
      logoLogin: "/static/images/nengrenjie/logo.png",
      backgroundImg: "/static/images/nengrenjie/banner.jpg",
      icoUrl: "/static/images/nengrenjie/default.ico",
      siderLogo: "/static/images/nengrenjie/siderLogo.png"
    },
    'khl-xlt.51xinlong.com': {
      ename: "xinlingtong",
      title: "薪灵通",
      domain: "khl-xlt.51xinlong.com",
      logo: "/static/images/xinlingtong/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xinlingtong/logo.png",
      backgroundImg: "/static/images/xinlingtong/banner.jpg",
      icoUrl: "/static/images/xinlingtong/default.ico",
      siderLogo: "/static/images/xinlingtong/siderLogo.png"
    },
    'khl-brrl.51xinlong.com': {
      ename: "borurenli",
      title: "博儒人力",
      domain: "khl-brrl.51xinlong.com",
      logo: "/static/images/zhonghengli/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zhonghengli/logo.png",
      backgroundImg: "/static/images/xinlingtong/banner.jpg",
      icoUrl: "/static/images/zhonghengli/default.ico",
      siderLogo: "/static/images/borurenli/siderLogo.png"
    },
    'khl-jyx.51xinlong.com': {
      ename: "juyouxin",
      title: "聚优薪",
      domain: "khl-jyx.51xinlong.com",
      logo: "/static/images/juyouxin/logo.png",
      logoTop: "",
      logoLogin: "/static/images/juyouxin/logo.png",
      backgroundImg: "/static/images/juyouxin/banner.jpg",
      icoUrl: "/static/images/juyouxin/default.ico",
      siderLogo: "/static/images/juyouxin/siderLogo.png"
    },
    'www.toploong.top': {
      ename: "toubulong",
      title: "头部龙",
      domain: "www.toploong.top",
      logo: "/static/images/toubulong/logo.png",
      logoTop: "",
      logoLogin: "/static/images/toubulong/logo.png",
      backgroundImg: "/static/images/toubulong/banner.jpg",
      icoUrl: "/static/images/toubulong/default.ico",
      siderLogo: "/static/images/toubulong/siderLogo.png",
      beianCode:"浙ICP备2021024189号"
    },
    'ph.anshizixun.com': {
      ename: "anshizixun",
      title: "安释科创研发众包平台",
      domain: "ph.anshizixun.com",
      logo: "/static/images/anshizixun/logo.png",
      logoTop: "",
      logoLogin: "/static/images/anshizixun/logo.png",
      backgroundImg: "/static/images/anshizixun/banner.jpg",
      icoUrl: "/static/images/anshizixun/default.ico",
      siderLogo: "/static/images/anshizixun/siderLogo.png"
    },
    'khl-mfrl.51xinlong.com': {
      ename: "mifenghulian",
      title: "蜜蜂互联",
      domain: "khl-mfrl.51xinlong.com",
      logo: "/static/images/mifeng/logo.png",
      logoTop: "",
      logoLogin: "/static/images/mifeng/logo.png",
      backgroundImg: "/static/images/mifeng/banner.jpg",
      icoUrl: "/static/images/mifeng/default.ico",
      siderLogo: "/static/images/mifeng/siderLogo.png"
    },
    'khl-qbw.51xinlong.com': {
      ename: "qibanwang",
      title: "企办网",
      domain: "khl-qbw.51xinlong.com",
      logo: "/static/images/qibanwang/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qibanwang/logo.png",
      backgroundImg: "/static/images/qibanwang/banner.jpg",
      icoUrl: "/static/images/qibanwang/default.ico",
      siderLogo: "/static/images/qibanwang/siderLogo.png"
    },
    'khl-xr.51xinlong.com': {
      ename: "xinrong",
      title: "昕融",
      domain: "khl-xr.51xinlong.com",
      logo: "/static/images/xinrong/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xinrong/logo.png",
      backgroundImg: "/static/images/xinrong/banner.jpg",
      icoUrl: "/static/images/xinrong/default.ico",
      siderLogo: "/static/images/xinrong/siderLogo.png"
    },
    'saas.all4onetech.com': {
      ename: "hangzhi",
      title: "行置科技",
      domain: "saas.all4onetech.com",
      logo: "/static/images/hangzhi/logo.png",
      logoTop: "",
      logoLogin: "/static/images/hangzhi/logo.png",
      backgroundImg: "/static/images/hangzhi/banner.jpg",
      icoUrl: "/static/images/hangzhi/default.ico",
      siderLogo: "/static/images/hangzhi/siderLogo.png"
    },
    'www.xmpalm.com': {
      ename: "xiangqing",
      title: "手掌薪",
      domain: "www.xmpalm.com",
      logo: "/static/images/szx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/szx/logo.png",
      backgroundImg: "/static/images/szx/banner.jpg",
      icoUrl: "/static/images/szx/default.ico",
      siderLogo: "/static/images/szx/siderLogo.png"
    },
    'khl-lm.51xinlong.com': {
      ename: "lvcheng",
      title: "绿城租售中心",
      domain: "khl-lm.51xinlong.com",
      logo: "/static/images/lvcheng/logo.png",
      logoTop: "",
      logoLogin: "/static/images/lvcheng/logo.png",
      backgroundImg: "/static/images/lvcheng/banner.jpg",
      icoUrl: "/static/images/lvcheng/default.ico",
      siderLogo: "/static/images/lvcheng/siderLogo.png"
    },
    'vip.catdo.cn': {
      ename: "bojin",
      title: "灵动猫",
      domain: "vip.catdo.cn",
      logo: "/static/images/bojin/logo.png",
      logoTop: "",
      logoLogin: "/static/images/bojin/logo.png",
      backgroundImg: "/static/images/bojin/banner.jpg",
      icoUrl: "/static/images/bojin/default.ico",
      siderLogo: "/static/images/bojin/siderLogo.png"
    },
    'khl-cdrl.51xinlong.com': {
      ename: "chuangda",
      title: "创达财税",
      domain: "khl-cdrl.51xinlong.com",
      logo: "/static/images/chuangda/logo.png",
      logoTop: "",
      logoLogin: "/static/images/chuangda/logo.png",
      backgroundImg: "/static/images/chuangda/banner.jpg",
      icoUrl: "/static/images/chuangda/default.ico",
      siderLogo: "/static/images/chuangda/siderLogo.png"
    },
    'khl-jyg.51xinlong.com': {
      ename: "juyonggong",
      title: "聚用工网络",
      domain: "khl-jyg.51xinlong.com",
      logo: "/static/images/juyonggong/logo.png",
      logoTop: "",
      logoLogin: "/static/images/juyonggong/logo.png",
      backgroundImg: "/static/images/juyonggong/banner.jpg",
      icoUrl: "/static/images/juyonggong/default.ico",
      siderLogo: "/static/images/juyonggong/siderLogo.png"
    },
    'saas.xyg998.com': {
      ename: "xinyuangong",
      title: "薪员工",
      domain: "saas.xyg998.com",
      logo: "/static/images/xinyuangong/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xinyuangong/logo.png",
      backgroundImg: "/static/images/xinyuangong/banner.jpg",
      icoUrl: "/static/images/xinyuangong/default.ico",
      siderLogo: "/static/images/xinyuangong/siderLogo.png"
    },
    'khl-jskj.51xinlong.com': {
      ename: "jiusheng",
      title: "玖晟科技",
      domain: "khl-jskj.51xinlong.com",
      logo: "/static/images/jiusheng/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jiusheng/logo.png",
      backgroundImg: "/static/images/jiusheng/banner.jpg",
      icoUrl: "/static/images/jiusheng/default.ico",
      siderLogo: "/static/images/jiusheng/siderLogo.png"
    },
    'saas.kindsun.com.cn': {
      ename: "qianshan",
      title: "千善数字",
      domain: "saas.kindsun.com.cn",
      logo: "/static/images/qssz/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qssz/logo.png",
      backgroundImg: "/static/images/qssz/banner.jpg",
      icoUrl: "/static/images/qssz/default.ico",
      siderLogo: "/static/images/qssz/siderLogo.png"
    },
    'khl-hxjc.51xinlong.com': {
      ename: "huaxia",
      title: "华夏君成",
      domain: "khl-hxjc.51xinlong.com",
      logo: "/static/images/hxjc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/hxjc/logo.png",
      backgroundImg: "/static/images/hxjc/banner.jpg",
      icoUrl: "/static/images/hxjc/default.ico",
      siderLogo: "/static/images/hxjc/siderLogo.png"
    },
    'khl-cxkj.51xinlong.com': {
      ename: "xincai",
      title: "薪财科技",
      domain: "khl-cxkj.51xinlong.com",
      logo: "/static/images/xckj/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xckj/logo.png",
      backgroundImg: "/static/images/xckj/banner.jpg",
      icoUrl: "/static/images/xckj/default.ico",
      siderLogo: "/static/images/xckj/siderLogo.png"
    },
    'khl-gzy.51xinlong.com': {
      ename: "guozhiyun",
      title: "国智云",
      domain: "khl-gzy.51xinlong.com",
      logo: "/static/images/gzy/logo.png",
      logoTop: "",
      logoLogin: "/static/images/gzy/logo.png",
      backgroundImg: "/static/images/gzy/banner.jpg",
      icoUrl: "/static/images/gzy/default.ico",
      siderLogo: "/static/images/gzy/siderLogo.png"
    },
    'saas.lantushuichou.com': {
      ename: "lantuwanxiang",
      title: "蓝图万象",
      domain: "saas.lantushuichou.com",
      logo: "/static/images/ltwx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ltwx/logo.png",
      backgroundImg: "/static/images/ltwx/banner.jpg",
      icoUrl: "/static/images/ltwx/default.ico",
      siderLogo: "/static/images/ltwx/siderLogo.png"
    },
    'saas.lanlingcb.com': {
      ename: "lanlingchengbang",
      title: "蓝领城邦",
      domain: "saas.lanlingcb.com",
      logo: "/static/images/llcb/logo.png",
      logoTop: "",
      logoLogin: "/static/images/llcb/logo.png",
      backgroundImg: "/static/images/llcb/banner.jpg",
      icoUrl: "/static/images/llcb/default.ico",
      siderLogo: "/static/images/llcb/siderLogo.png"
    },
'khl-zxzx.51xinlong.com': {
      ename: "zhongxin",
      title: "中鑫",
      domain: "khl-zxzx.51xinlong.com",
      logo: "/static/images/zx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zx/logo.png",
      backgroundImg: "/static/images/zx/banner.jpg",
      icoUrl: "/static/images/zx/default.ico",
      siderLogo: "/static/images/zx/siderLogo.png"
    },
    'khl-xlkj.51xinlong.com': {
      ename: "xinlingkeji",
      title: "薪灵科技",
      domain: "khl-xlkj.51xinlong.com",
      logo: "/static/images/xlkj/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xlkj/logo.png",
      backgroundImg: "/static/images/xlkj/banner.jpg",
      icoUrl: "/static/images/xlkj/default.ico",
      siderLogo: "/static/images/xlkj/siderLogo.png"
    },
    'saas.zchear.com': {
      ename: "zhichengqifu",
      title: "志成企服",
      domain: "saas.zchear.com",
      logo: "/static/images/zcqf/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zcqf/logo.png",
      backgroundImg: "/static/images/zcqf/banner.jpg",
      icoUrl: "/static/images/zcqf/default.ico",
      siderLogo: "/static/images/zcqf/siderLogo.png"
    },
    'khl-yymk.51xinlong.com': {
      ename: "yunyoumaike",
      title: "云优麦客",
      domain: "khl-yymk.51xinlong.com",
      logo: "/static/images/yymk/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yymk/logo.png",
      backgroundImg: "/static/images/yymk/banner.jpg",
      icoUrl: "/static/images/yymk/default.ico",
      siderLogo: "/static/images/yymk/siderLogo.png"
    },
    'khl-xsf.51xinlong.com': {
      ename: "xinshanfu",
      title: "薪闪付",
      domain: "khl-xsf.51xinlong.com",
      logo: "/static/images/xsf/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xsf/logo.png",
      backgroundImg: "/static/images/xsf/banner.jpg",
      icoUrl: "/static/images/xsf/default.ico",
      siderLogo: "/static/images/xsf/siderLogo.png"
    },
    'saas.bthzrl.com': {
      ename: "fangxinfa",
      title: "放薪发",
      domain: "saas.bthzrl.com",
      logo: "/static/images/fxf/logo.png",
      logoTop: "",
      logoLogin: "/static/images/fxf/logo.png",
      backgroundImg: "/static/images/fxf/banner.jpg",
      icoUrl: "/static/images/fxf/default.ico",
      siderLogo: "/static/images/fxf/siderLogo.png"
    },
    'khl-lqqf.51xinlong.com': {
      ename: "lianqiqifu",
      title: "联企企服",
      domain: "khl-lqqf.51xinlong.com",
      logo: "/static/images/lqqf/logo.png",
      logoTop: "",
      logoLogin: "/static/images/lqqf/logo.png",
      backgroundImg: "/static/images/lqqf/banner.jpg",
      icoUrl: "/static/images/lqqf/default.ico",
      siderLogo: "/static/images/lqqf/siderLogo.png"
    },
    'saas.sxhcrl.cn': {
      ename: "hancheng",
      title: "翰晟",
      domain: "saas.sxhcrl.cn",
      logo: "/static/images/hc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/hc/logo.png",
      backgroundImg: "/static/images/hc/banner.jpg",
      icoUrl: "/static/images/hc/default.ico",
      siderLogo: "/static/images/hc/siderLogo.png"
    },
    'khl-ysh.51xinlong.com': {
      ename: "yousuiyun",
      title: "优税云",
      domain: "khl-ysh.51xinlong.com",
      logo: "/static/images/ysh/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ysh/logo.png",
      backgroundImg: "/static/images/ysh/banner.jpg",
      icoUrl: "/static/images/ysh/default.ico",
      siderLogo: "/static/images/ysh/siderLogo.png"
    },
    'khl-shr.51xinlong.com': {
      ename: "suihuirong",
      title: "穗惠荣",
      domain: "khl-shr.51xinlong.com",
      logo: "/static/images/shr/logo.png",
      logoTop: "",
      logoLogin: "/static/images/shr/logo.png",
      backgroundImg: "/static/images/shr/banner.jpg",
      icoUrl: "/static/images/shr/default.ico",
      siderLogo: "/static/images/shr/siderLogo.png",
      appId: '10005'
    },
    'khl-xcx.51xinlong.com': {
      ename: "xinchangxiang",
      title: "薪畅向",
      domain: "khl-xcx.51xinlong.com",
      logo: "/static/images/xcx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xcx/logo.png",
      backgroundImg: "/static/images/xcx/banner.jpg",
      icoUrl: "/static/images/xcx/default.ico",
      siderLogo: "/static/images/xcx/siderLogo.png"
    },
    'khl-ytrl.51xinlong.com': {
      ename: "yintong",
      title: "银通人力",
      domain: "khl-ytrl.51xinlong.com",
      logo: "/static/images/yt/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yt/logo.png",
      backgroundImg: "/static/images/yt/banner.jpg",
      icoUrl: "/static/images/yt/default.ico",
      siderLogo: "/static/images/yt/siderLogo.png"
    },
    'khl-fxb.51xinlong.com': {
      ename: "fuxinbao",
      title: "付薪宝",
      domain: "khl-fxb.51xinlong.com",
      logo: "/static/images/fxb/logo.png",
      logoTop: "",
      logoLogin: "/static/images/fxb/logo.png",
      backgroundImg: "/static/images/fxb/banner.jpg",
      icoUrl: "/static/images/fxb/default.ico",
      siderLogo: "/static/images/fxb/siderLogo.png"
    },
'khl-zsbt.51xinlong.com': {
      ename: "zhongshengbotai",
      title: "中圣博泰",
      domain: "khl-zsbt.51xinlong.comkh",
      logo: "/static/images/zstb/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zstb/logo.png",
      backgroundImg: "/static/images/zstb/banner.jpg",
      icoUrl: "/static/images/zstb/default.ico",
      siderLogo: "/static/images/zstb/siderLogo.png"
    },
    'khl-syzs.51xinlong.com': {
      ename: "shuiyinzhushou",
      title: "税银助手",
      domain: "khl-syzs.51xinlong.com",
      logo: "/static/images/syzs/logo.png",
      logoTop: "",
      logoLogin: "/static/images/syzs/logo.png",
      backgroundImg: "/static/images/syzs/banner.jpg",
      icoUrl: "/static/images/syzs/default.ico",
      siderLogo: "/static/images/syzs/siderLogo.png"
    },
    'khl-kfx.51xinlong.com': {
      ename: "kuaifaxin",
      title: "快发薪",
      domain: "khl-kfx.51xinlong.com",
      logo: "/static/images/kfx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/kfx/logo.png",
      backgroundImg: "/static/images/kfx/banner.jpg",
      icoUrl: "/static/images/kfx/default.ico",
      siderLogo: "/static/images/kfx/siderLogo.png"
    },
    'khl-xxb.51xinlong.com': {
      ename: "xinxinbao",
      title: "薪薪宝",
      domain: "khl-xxb.51xinlong.com",
      logo: "/static/images/xxb/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xxb/logo.png",
      backgroundImg: "/static/images/xxb/banner.jpg",
      icoUrl: "/static/images/xxb/default.ico",
      siderLogo: "/static/images/xxb/siderLogo.png"
    },
    'saas.51zhongxiu.com': {
      ename: "xindongxiang",
      title: "薪动象",
      domain: "saas.51zhongxiu.com",
      logo: "/static/images/xdx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xdx/logo.png",
      backgroundImg: "/static/images/xdx/banner.jpg",
      icoUrl: "/static/images/xdx/default.ico",
      siderLogo: "/static/images/xdx/siderLogo.png"
    },
    'khl-zbwh.51xinlong.com': {
      ename: "zuanbaowenhua",
      title: "钻豹文化",
      domain: "khl-zbwh.51xinlong.com",
      logo: "/static/images/zbwh/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zbwh/logo.png",
      backgroundImg: "/static/images/zbwh/banner.jpg",
      icoUrl: "/static/images/zbwh/default.ico",
      siderLogo: "/static/images/zbwh/siderLogo.png"
    },
  'www.kaiyuanstaff.com': {
      ename: "kaiyuan",
      title: "开源",
      domain: "www.kaiyuanstaff.com",
      logo: "/static/images/ky/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ky/logo.png",
      backgroundImg: "/static/images/ky/banner.jpg",
      icoUrl: "/static/images/ky/default.ico",
      siderLogo: "/static/images/ky/siderLogo.png"
    },
    'khl-qfwl.51xinlong.com': {
      ename: "qunfengwangluo",
      title: "群蜂网络",
      domain: "khl-qfwl.51xinlong.com",
      logo: "/static/images/qfwl/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qfwl/logo.png",
      backgroundImg: "/static/images/qfwl/banner.jpg",
      icoUrl: "/static/images/qfwl/default.ico",
      siderLogo: "/static/images/qfwl/siderLogo.png"
    },
    'www.hudarenzi.com': {
      ename: "hudarenzi",
      title: "沪达人资",
      domain: "www.hudarenzi.com",
      logo: "/static/images/hdrz/logo.png",
      logoTop: "",
      logoLogin: "/static/images/hdrz/logo.png",
      backgroundImg: "/static/images/hdrz/banner.jpg",
      icoUrl: "/static/images/hdrz/default.ico",
      siderLogo: "/static/images/hdrz/siderLogo.png"
      },
	'khl-hfx.51xinlong.com': { 
	ename: "linggongling",
	title: "灵工灵",
	domain: "khl-hfx.51xinlong.com",
	logo: "/static/images/lgl/logo.png",
	logoTop: "",
	logoLogin: "/static/images/lgl/logo.png",
	backgroundImg: "/static/images/lgl/banner.jpg",
	icoUrl: "/static/images/lgl/default.ico",
	siderLogo: "/static/images/lgl/siderLogo.png" 
	},
	'khl-glrl.51xinlong.com': {
	ename: "guoqingrenli",
	title: "国勤人力",
	domain: "khl-glrl.51xinlong.com",
	logo: "/static/images/szx/logo.png",
	logoTop: "",
	logoLogin: "/static/images/szx/logo.png",
	backgroundImg: "/static/images/szx/banner.jpg",
	icoUrl: "/static/images/szx/default.ico",
	siderLogo: "/static/images/szx/siderLogo.png" 
	},
	'khl-wdycs.51xinlong.com': {
	ename: "wendayuancaishui",
	title: "文达圆财税",
	domain: "khl-wdycs.51xinlong.com",
	logo: "/static/images/wdycs/logo.png",
	logoTop: "",
	logoLogin: "/static/images/wdycs/logo.png",
	backgroundImg: "/static/images/wdycs/banner.jpg",
	icoUrl: "/static/images/wdycs/default.ico",
	siderLogo: "/static/images/wdycs/siderLogo.png" 
	},
	'khl-xash.51xinlong.com': {
	ename: "xianshanghaoszx",
	title: "西安商皓",
	domain: "khl-xash.51xinlong.com",
	logo: "/static/images/xash/logo.png", 
	logoTop: "",
	logoLogin: "/static/images/xash/logo.png",
	backgroundImg: "/static/images/xash/banner.jpg",
	icoUrl: "/static/images/xash/default.ico",
	siderLogo: "/static/images/xash/siderLogo.png" 
	},
	'khl-sjl.51xinlong.com': {
	ename: "shuijiling",
	title: "水吉灵",
	domain: "khl-sjl.51xinlong.com",
	logo: "/static/images/sjl/logo.png", 
	logoTop: "",
	logoLogin: "/static/images/sjl/logo.png",
	backgroundImg: "/static/images/sjl/banner.jpg",
	icoUrl: "/static/images/sjl/default.ico",
	siderLogo: "/static/images/sjl/siderLogo.png" 
	},
  'khl-fhcs.51xinlong.com': {
    ename: "fuhecaishui",
    title: "富合财税",
    domain: "khl-fhcs.51xinlong.com",
    logo: "/static/images/fhcs/logo.png", 
    logoTop: "",
    logoLogin: "/static/images/fhcs/logo.png",
    backgroundImg: "/static/images/fhcs/banner.jpg",
    icoUrl: "/static/images/fhcs/default.ico",
    siderLogo: "/static/images/fhcs/siderLogo.png" 
    },
    'khl-yzs.51xinlong.com': {
    ename: "shancaiqifu",
    title: "善财企服",
    domain: "khl-yzs.51xinlong.com",
    logo: "/static/images/scqf/logo.png", 
    logoTop: "",
    logoLogin: "/static/images/scqf/logo.png",
    backgroundImg: "/static/images/scqf/banner.jpg",
    icoUrl: "/static/images/scqf/default.ico",
    siderLogo: "/static/images/scqf/siderLogo.png" 
      },
      'khl-xxrl.51xinlong.com': {
    ename: "xingxinrenli",
    title: "兴信人力",
    domain: "khl-xxrl.51xinlong.com",
    logo: "/static/images/xxrl/logo.png", 
    logoTop: "",
    logoLogin: "/static/images/xxrl/logo.png",
    backgroundImg: "/static/images/xxrl/banner.jpg",
    icoUrl: "/static/images/xxrl/default.ico",
    siderLogo: "/static/images/xxrl/siderLogo.png" 
     },
     'khl-lblg.51xinlong.com': {
      ename: "lianbeilinggong",
      title: "联贝灵工",
      domain: "khl-lblg.51xinlong.com",
      logo: "/static/images/lblg/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/lblg/logo.png",
      backgroundImg: "/static/images/lblg/banner.jpg",
      icoUrl: "/static/images/lblg/default.ico",
      siderLogo: "/static/images/lblg/siderLogo.png" 
       },
     'khl-fcd.51xinlong.com': {
      ename: "fangcaodichuanmei",
      title: "芳草地传媒",
      domain: "khl-fcd.51xinlong.com",
      logo: "/static/images/fcdcm/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/fcdcm/logo.png",
      backgroundImg: "/static/images/fcdcm/banner.jpg",
      icoUrl: "/static/images/fcdcm/default.ico",
      siderLogo: "/static/images/fcdcm/siderLogo.png"
     },
     'lhyg.qihaoyunwang.com': {
      ename: "qihaoyun",
      title: "企好运",
      domain: "lhyg.qihaoyunwang.com",
      logo: "/static/images/qhy/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/qhy/logo.png",
      backgroundImg: "/static/images/qhy/banner.jpg",
      icoUrl: "/static/images/qhy/default.ico",
      siderLogo: "/static/images/qhy/siderLogo.png"
     },
     'khl-qch.51xinlong.com': {
      ename: "qicaihui",
      title: "企才惠",
      domain: "khl-qch.51xinlong.com",
      logo: "/static/images/szx/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/szx/logo.png",
      backgroundImg: "/static/images/szx/banner.jpg",
      icoUrl: "/static/images/szx/default.ico",
      siderLogo: "/static/images/szx/siderLogo.png"
     },
     'khl-ycyy.51xinlong.com': {
      ename: "yingchuang",
      title: "赢创",
      domain: "khl-ycyy.51xinlong.com",
      logo: "/static/images/yc/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/yc/logo.png",
      backgroundImg: "/static/images/yc/banner.jpg",
      icoUrl: "/static/images/yc/default.ico",
      siderLogo: "/static/images/yc/siderLogo.png"
     },
     'jiejiao.51xinlong.com': {
      ename: "yunqi",
      title: "云企",
      domain: "jiejiao.51xinlong.com",
      logo: "/static/images/szx/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/szx/logo.png",
      backgroundImg: "/static/images/szx/banner.jpg",
      icoUrl: "/static/images/szx/default.ico",
      siderLogo: "/static/images/szx/siderLogo.png"
    },
    'khl-bgkj.51xinlong.com': {
      ename: "baogukeji",
      title: "包谷科技",
      domain: "khl-bgkj.51xinlong.com",
      logo: "/static/images/bgkj/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/bgkj/logo.png",
      backgroundImg: "/static/images/bgkj/banner.jpg",
      icoUrl: "/static/images/bgkj/default.ico",
      siderLogo: "/static/images/bgkj/siderLogo.png"
    },
    'khl-zyt.51xinlong.com': {
      ename: "zhanyoutan",
      title: "绽优昙",
      domain: "khl-zyt.51xinlong.com",
      logo: "/static/images/zyt/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/zyt/logo.png",
      backgroundImg: "/static/images/zyt/banner.jpg",
      icoUrl: "/static/images/zyt/default.ico",
      siderLogo: "/static/images/zyt/siderLogo.png"
    },
    'khljiufx.51xinlong.com': {
      ename: "jiufenxiang",
      title: "酒分享",
      domain: "khljiufx.51xinlong.com",
      logo: "/static/images/jfx/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/jfx/logo.png",
      backgroundImg: "/static/images/jfx/banner.jpg",
      icoUrl: "/static/images/jfx/default.ico",
      siderLogo: "/static/images/jfx/siderLogo.png"
    },
    'khl-tbky.51xinlong.com': {
      ename: "tianbaopkeji",
      title: "天宝科技",
      domain: "khl-tbky.51xinlong.com",
      logo: "/static/images/tbkj/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/tbkj/logo.png",
      backgroundImg: "/static/images/tbkj/banner.jpg",
      icoUrl: "/static/images/tbkj/default.ico",
      siderLogo: "/static/images/tbkj/siderLogo.png"
    },
    'khl-hkds.51xinlong.com': {
      ename: "huakaidingsheng",
      title: "华凯鼎盛",
      domain: "khl-hkds.51xinlong.com",
      logo: "/static/images/hkds/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/hkds/logo.png",
      backgroundImg: "/static/images/hkds/banner.jpg",
      icoUrl: "/static/images/hkds/default.ico",
      siderLogo: "/static/images/hkds/siderLogo.png"
    },
    'khl-lwqg.51xinlong.com': {
      ename: "lingweiqiguan",
      title: "云工桥",
      domain: "khl-lwqg.51xinlong.com",
      logo: "/static/images/lwqg/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/lwqg/logo.png",
      backgroundImg: "/static/images/lwqg/banner.jpg",
      icoUrl: "/static/images/lwqg/default.ico",
      siderLogo: "/static/images/lwqg/siderLogo.png"
    },
    'manage.sxjinhui.cn': {
      ename: "jinhuijituan",
      title: "晋汇集团",
      domain: "manage.sxjinhui.cn",
      logo: "/static/images/jhjt/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/jhjt/logo.png",
      backgroundImg: "/static/images/jhjt/banner.jpg",
      icoUrl: "/static/images/jhjt/default.ico",
      siderLogo: "/static/images/jhjt/siderLogo.png"
    },
    'khl-yssj.51xinlong.com': {
      ename: "yushanshuju",
      title: "羽山数据",
      domain: "khl-yssj.51xinlong.com",
      logo: "/static/images/yssj/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/yssj/logo.png",
      backgroundImg: "/static/images/yssj/banner.jpg",
      icoUrl: "/static/images/yssj/default.ico",
      siderLogo: "/static/images/yssj/siderLogo.png"
    },
    'khl-ddqf.51xinlong.com': {
      ename: "dingdingqifu",
      title: "顶顶企服",
      domain: "khl-ddqf.51xinlong.com",
      logo: "/static/images/szx/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/szx/logo.png",
      backgroundImg: "/static/images/szx/banner.jpg",
      icoUrl: "/static/images/szx/default.ico",
      siderLogo: "/static/images/szx/siderLogo.png"
    },
    'www.shuilili.com': {
      ename: "shuilili",
      title: "税理理",
      domain: "www.shuilili.com",
      logo: "/static/images/sll/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/sll/logo.png",
      backgroundImg: "/static/images/sll/banner.jpg",
      icoUrl: "/static/images/sll/default.ico",
      siderLogo: "/static/images/sll/siderLogo.png",
      beianCode: '桂ICP备2021009733号-1'
    },
    'khl-mjrc.51xinlong.com': {
      ename: "dalianmingjierencai",
      title: "大连鸣捷人才",
      domain: "khl-mjrc.51xinlong.com",
      logo: "/static/images/dlmjrc/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/dlmjrc/logo.png",
      backgroundImg: "/static/images/dlmjrc/banner.jpg",
      icoUrl: "/static/images/dlmjrc/default.ico",
      siderLogo: "/static/images/dlmjrc/siderLogo.png"
    },
    'khl-yyg.51xinlong.com': {
      ename: "yiyonggong",
      title: "壹用工",
      domain: "khl-yyg.51xinlong.com",
      logo: "/static/images/yyg/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/yyg/logo.png",
      backgroundImg: "/static/images/yyg/banner.jpg",
      icoUrl: "/static/images/yyg/default.ico",
      siderLogo: "/static/images/yyg/siderLogo.png"
    },
    'khl-ruic.51xinlong.com': {
      ename: "ruichi",
      title: "芮驰",
      domain: "khl-ruic.51xinlong.com",
      logo: "/static/images/bc/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/bc/logo.png",
      backgroundImg: "/static/images/bc/banner.jpg",
      icoUrl: "/static/images/bc/default.ico",
      siderLogo: "/static/images/bc/siderLogo.png"
    },
    'saas.dahuarl.com': {
      ename: "huashixinping",
      title: "华视薪聘",
      domain: "saas.dahuarl.com",
      logo: "/static/images/hsxp/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/hsxp/logo.png",
      backgroundImg: "/static/images/hsxp/banner.jpg",
      icoUrl: "/static/images/hsxp/default.ico",
      siderLogo: "/static/images/hsxp/siderLogo.png"
    },
    'www.ctkjlg.com': {
      ename: "chuangtuokongjian",
      title: "创拓空间",
      domain: "www.ctkjlg.com",
      logo: "/static/images/ctkj/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/ctkj/logo.png",
      backgroundImg: "/static/images/ctkj/banner.jpg",
      icoUrl: "/static/images/ctkj/default.ico",
      siderLogo: "/static/images/ctkj/siderLogo.png"
    },
    'khl-yqrl.51xinlong.com': {
      ename: "yueqirenli",
      title: "越奇人力",
      domain: "khl-yqrl.51xinlong.com",
      logo: "/static/images/yqrl/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/yqrl/logo.png",
      backgroundImg: "/static/images/yqrl/banner.jpg",
      icoUrl: "/static/images/yqrl/default.ico",
      siderLogo: "/static/images/yqrl/siderLogo.png"
    },
    'khl-jsz.51xinlong.com': {
      ename: "jinshouzhi",
      title: "金手指",
      domain: "khl-jsz.51xinlong.com",
      logo: "/static/images/jsz/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/jsz/logo.png",
      backgroundImg: "/static/images/jsz/banner.jpg",
      icoUrl: "/static/images/jsz/default.ico",
      siderLogo: "/static/images/jsz/siderLogo.png"
    },
    'saas.yueleics.com': {
      ename: "yueleicaishui",
      title: "岳磊财税",
      domain: "saas.yueleics.com",
      logo: "/static/images/ylcs/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/ylcs/logo.png",
      backgroundImg: "/static/images/ylcs/banner.jpg",
      icoUrl: "/static/images/ylcs/default.ico",
      siderLogo: "/static/images/ylcs/siderLogo.png",
      beianCode: '津ICP备2021009364号-1'
    },
    'khl-mxjs.51xinlong.com': {
      ename: "meixinjieshui",
      title: "美薪节税",
      domain: "khl-mxjs.51xinlong.com",
      logo: "/static/images/mxjs/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/mxjs/logo.png",
      backgroundImg: "/static/images/mxjs/banner.jpg",
      icoUrl: "/static/images/mxjs/default.ico",
      siderLogo: "/static/images/mxjs/siderLogo.png"
    },
    'khl-scrl.51xinlong.com': {
      ename: "shengchuangrenli",
      title: "盛创人力",
      domain: "khl-scrl.51xinlong.com",
      logo: "/static/images/scrl/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/scrl/logo.png",
      backgroundImg: "/static/images/scrl/banner.jpg",
      icoUrl: "/static/images/scrl/default.ico",
      siderLogo: "/static/images/scrl/siderLogo.png"
    },
    'khl-yiy.51xinlong.com': {
      ename: "yiying",
      title: "颐赢",
      domain: "khl-yiy.51xinlong.com",
      logo: "/static/images/yy/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/yy/logo.png",
      backgroundImg: "/static/images/yy/banner.jpg",
      icoUrl: "/static/images/yy/default.ico",
      siderLogo: "/static/images/yy/siderLogo.png"
    },
    'www.51aixinyun.com': {
      ename: "aixinyun",
      title: "爱薪云客户登录端",
      domain: "www.51aixinyun.com",
      logo: "/static/images/axy/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/axy/logo.png",
      backgroundImg: "/static/images/axy/banner.jpg",
      icoUrl: "/static/images/axy/default.ico",
      siderLogo: "/static/images/axy/siderLogo.png",
      beianCode:"沪ICP备2022005292号-1"
    },
    'khl-zly.51xinlong.com': {
      ename: "zhonglengyun",
      title: "中冷运",
      domain: "khl-zly.51xinlong.com",
      logo: "/static/images/zly/logo.png", 
      logoTop: "",
      logoLogin: "/static/images/zly/logo.png",
      backgroundImg: "/static/images/zly/banner.jpg",
      icoUrl: "/static/images/zly/default.ico",
      siderLogo: "/static/images/zly/siderLogo.png"
    },
    'khl-qyls.51xinlong.com': {
      ename: "qingyunlishui",
      title: "青云理税",
      domain: "khl-qyls.51xinlong.com", 
      logo: "/static/images/qyls/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qyls/logo.png",
      backgroundImg: "/static/images/qyls/banner.jpg",
      icoUrl: "/static/images/qyls/default.ico",
      siderLogo: "/static/images/qyls/siderLogo.png"
    },
    'zhinengxin.51xinlong.com': {
      ename: "zhinengxing",
      title: "智能薪",
      domain: "zhinengxin.51xinlong.com", 
      logo: "/static/images/znxing/logo.png",
      logoTop: "",
      logoLogin: "/static/images/znxing/logo.png",
      backgroundImg: "/static/images/znxing/banner.jpg",
      icoUrl: "/static/images/znxing/default.ico",
      siderLogo: "/static/images/znxing/siderLogo.png"
    },
    'khl-yxkj.51xinlong.com': {
      ename: "yunxin",
      title: "云薪",
      domain: "khl-yxkj.51xinlong.com", 
      logo: "/static/images/yxing/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yxing/logo.png",
      backgroundImg: "/static/images/yxing/banner.jpg",
      icoUrl: "/static/images/yxing/default.ico",
      siderLogo: "/static/images/yxing/siderLogo.png"
    },
    'khl-zcm.51xinlong.com': {
      ename: "zhaocaimao",
      title: "招财猫",
      domain: "khl-zcm.51xinlong.com", 
      logo: "/static/images/zcm/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zcm/logo.png",
      backgroundImg: "/static/images/zcm/banner.jpg",
      icoUrl: "/static/images/zcm/default.ico",
      siderLogo: "/static/images/zcm/siderLogo.png"
    },
    'khl-bhqg.51xinlong.com': {
      ename: "bohuaqiguan",
      title: "博华企管",
      domain: "khl-bhqg.51xinlong.com", 
      logo: "/static/images/bhqg/logo.png",
      logoTop: "",
      logoLogin: "/static/images/bhqg/logo.png",
      backgroundImg: "/static/images/bhqg/banner.jpg",
      icoUrl: "/static/images/bhqg/default.ico",
      siderLogo: "/static/images/bhqg/siderLogo.png"
    },
    'khl-xddq.51xinlong.com': {
      ename: "xiandaidianqi",
      title: "现戴电器",
      domain: "khl-xddq.51xinlong.com", 
      logo: "/static/images/xddq/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xddq/logo.png",
      backgroundImg: "/static/images/xddq/banner.jpg",
      icoUrl: "/static/images/xddq/default.ico",
      siderLogo: "/static/images/xddq/siderLogo.png"
    },
    'khl-jhrl.51xinlong.com': {
      ename: "jiaherenli",
      title: "嘉合人力",
      domain: "khl-jhrl.51xinlong.com", 
      logo: "/static/images/jhrl/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jhrl/logo.png",
      backgroundImg: "/static/images/jhrl/banner.jpg",
      icoUrl: "/static/images/jhrl/default.ico",
      siderLogo: "/static/images/jhrl/siderLogo.png"
    },
	'khl-zhc.51xinlong.com': {
      ename: "zhancai",
      title: "占才",
      domain: "khl-zhc.51xinlong.com", 
      logo: "/static/images/zhancai/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zhancai/logo.png",
      backgroundImg: "/static/images/zhancai/banner.jpg",
      icoUrl: "/static/images/zhancai/default.ico",
      siderLogo: "/static/images/zhancai/siderLogo.png"
	},
	'khl-jzhs.51xinlong.com': {
      ename: "jinzhangshi",
      title: "金账师",
      domain: "khl-jzhs.51xinlong.com", 
      logo: "/static/images/jinzhangshi/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jinzhangshi/logo.png",
      backgroundImg: "/static/images/jinzhangshi/banner.jpg",
      icoUrl: "/static/images/jinzhangshi/default.ico",
      siderLogo: "/static/images/jinzhangshi/siderLogo.png"
	},
	'khl-bsl.51xinlong.com': {
		ename: "boshenglong",
		title: "博胜隆",
		domain: "khl-bsl.51xinlong.com",
		logo: "/static/images/boshenglong/logo.png",
		logoTop: "",
		logoLogin: "/static/images/boshenglong/logo.png",
		backgroundImg: "/static/images/boshenglong/banner.jpg",
		icoUrl: "/static/images/boshenglong/default.ico",
		siderLogo: "/static/images/boshenglong/siderLogo.png",
	},
	'khl-qxb.51xinlong.com': {
		ename: "qixinbao",
		title: "企薪保",
		domain: "khl-qxb.51xinlong.com",
		logo: "/static/images/qixinbao/logo.png",
		logoTop: "",
		logoLogin: "/static/images/qixinbao/logo.png",
		backgroundImg: "/static/images/qixinbao/banner.jpg",
		icoUrl: "/static/images/qixinbao/default.ico",
		siderLogo: "/static/images/qixinbao/siderLogo.png",
	},
	'khl-hyt.51xinlong.com': {
		ename: "huaiyitong",
		title: "淮易通",
		domain: "khl-hyt.51xinlong.com",
		logo: "/static/images/huaiyitong/logo.png",
		logoTop: "",
		logoLogin: "/static/images/huaiyitong/logo.png",
		backgroundImg: "/static/images/huaiyitong/banner.jpg",
		icoUrl: "/static/images/huaiyitong/default.ico",
		siderLogo: "/static/images/huaiyitong/siderLogo.png",
	},
	'khl-shhy.51xinlong.com': {
		ename: "shengheyuan",
		title: "晟赫源",
		domain: "khl-shhy.51xinlong.com",
		logo: "/static/images/shengheyuan/logo.png",
		logoTop: "",
		logoLogin: "/static/images/shengheyuan/logo.png",
		backgroundImg: "/static/images/shengheyuan/banner.jpg",
		icoUrl: "/static/images/shengheyuan/default.ico",
		siderLogo: "/static/images/shengheyuan/siderLogo.png",
	},
	'khl-rongj.51xinlong.com': {
		ename: "rongjiang",
		title: "融江",
		domain: "khl-rongj.51xinlong.com",
		logo: "/static/images/rongjiang/logo.png",
		logoTop: "",
		logoLogin: "/static/images/rongjiang/logo.png",
		backgroundImg: "/static/images/rongjiang/banner.jpg",
		icoUrl: "/static/images/rongjiang/default.ico",
		siderLogo: "/static/images/rongjiang/siderLogo.png",
	},
	'khl-sanf.51xinlong.com': {
		ename: "sanfeng",
		title: "三枫",
		domain: "khl-sanf.51xinlong.com",
		logo: "/static/images/sanfeng/logo.png",
		logoTop: "",
		logoLogin: "/static/images/sanfeng/logo.png",
		backgroundImg: "/static/images/sanfeng/banner.jpg",
		icoUrl: "/static/images/sanfeng/default.ico",
		siderLogo: "/static/images/sanfeng/siderLogo.png",
	},
	'khl-xbl.51xinlong.com': {
		ename: "xinbailing",
		title: "薪百灵",
		domain: "khl-xbl.51xinlong.com",
		logo: "/static/images/xinbailing/logo.png",
		logoTop: "",
		logoLogin: "/static/images/xinbailing/logo.png",
		backgroundImg: "/static/images/xinbailing/banner.jpg",
		icoUrl: "/static/images/xinbailing/default.ico",
		siderLogo: "/static/images/xinbailing/siderLogo.png",
	},
	'khl-xsc.51xinlong.com': {
		ename: "xinshuichou",
		title: "薪税筹",
		domain: "khl-xsc.51xinlong.com",
		logo: "/static/images/xinshuichou/logo.png",
		logoTop: "",
		logoLogin: "/static/images/xinshuichou/logo.png",
		backgroundImg: "/static/images/xinshuichou/banner.jpg",
		icoUrl: "/static/images/xinshuichou/default.ico",
		siderLogo: "/static/images/xinshuichou/siderLogo.png",
	},
	'khl-xys.51xinlong.com': {
		ename: "xinyishui",
		title: "薪易税",
		domain: "khl-xys.51xinlong.com",
		logo: "/static/images/xinyishui/logo.png",
		logoTop: "",
		logoLogin: "/static/images/xinyishui/logo.png",
		backgroundImg: "/static/images/xinyishui/banner.jpg",
		icoUrl: "/static/images/xinyishui/default.ico",
		siderLogo: "/static/images/xinyishui/siderLogo.png",
	},
	'khl-jias.51xinlong.com': {
		ename: "jiasheng",
		title: "佳盛",
		domain: "khl-jias.51xinlong.com",
		logo: "/static/images/jiasheng/logo.png",
		logoTop: "",
		logoLogin: "/static/images/jiasheng/logo.png",
		backgroundImg: "/static/images/jiasheng/banner.jpg",
		icoUrl: "/static/images/jiasheng/default.ico",
		siderLogo: "/static/images/jiasheng/siderLogo.png",
	},
    'khl-hytx.51xinlong.com': {
		ename: "haoyuan",
		title: "浩远通讯",
		domain: "khl-hytx.51xinlong.com",
		logo: "/static/images/haoyuan/logo.png",
		logoTop: "",
		logoLogin: "/static/images/haoyuan/logo.png",
		backgroundImg: "/static/images/haoyuan/banner.jpg",
		icoUrl: "/static/images/haoyuan/default.ico",
		siderLogo: "/static/images/haoyuan/siderLogo.png",
    },
    'khl-xxyd.51xinlong.com': {
		ename: "xinxinyida",
		title: "鑫薪易达",
		domain: "khl-xxyd.51xinlong.com",
		logo: "/static/images/xinxinyida/logo.png",
		logoTop: "",
		logoLogin: "/static/images/xinxinyida/logo.png",
		backgroundImg: "/static/images/xinxinyida/banner.jpg",
		icoUrl: "/static/images/xinxinyida/default.ico",
		siderLogo: "/static/images/xinxinyida/siderLogo.png",
    },
	'khl-jlw.51xinlong.com': {
		ename: "jianlongwang",
		title: "见龙网",
		domain: "khl-jlw.51xinlong.com",
		logo: "/static/images/jianlongwang/logo.png",
		logoTop: "",
		logoLogin: "/static/images/jianlongwang/logo.png",
		backgroundImg: "/static/images/jianlongwang/banner.jpg",
		icoUrl: "/static/images/jianlongwang/default.ico",
		siderLogo: "/static/images/jianlongwang/siderLogo.png",
	},
	'khl-zcrl.51xinlong.com': {
		ename: "zhongchaung",
		title: "中创人力",
		domain: "khl-zcrl.51xinlong.com",
		logo: "/static/images/zhongchaung/logo.png",
		logoTop: "",
		logoLogin: "/static/images/zhongchaung/logo.png",
		backgroundImg: "/static/images/zhongchaung/banner.jpg",
		icoUrl: "/static/images/zhongchaung/default.ico",
		siderLogo: "/static/images/zhongchaung/siderLogo.png",
	},
    'khl-rywf.51xinlong.com': {
      ename: "renyiwofu",
      title: "人易沃福",
      domain: "khl-rywf.51xinlong.com", 
      logo: "/static/images/renyiwofu/logo.png",
      logoTop: "",
      logoLogin: "/static/images/renyiwofu/logo.png",
      backgroundImg: "/static/images/renyiwofu/banner.jpg",
      icoUrl: "/static/images/renyiwofu/default.ico",
      siderLogo: "/static/images/renyiwofu/siderLogo.png"
    },
    'saas.xrkcaishui.com': {
      ename: "xiangrikui",
      title: "向日葵财税",
      domain: "saas.xrkcaishui.com", 
      logo: "/static/images/xiangrikui/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xiangrikui/logo.png",
      backgroundImg: "/static/images/xiangrikui/banner.jpg",
      icoUrl: "/static/images/xiangrikui/default.ico",
      siderLogo: "/static/images/xiangrikui/siderLogo.png"
    },
    'www.freeman-pay.cn': {
      ename: "ziyouren",
      title: "自由人",
      domain: "www.freeman-pay.cn", 
      logo: "/static/images/ziyouren/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ziyouren/logo.png",
      backgroundImg: "/static/images/ziyouren/banner.jpg",
      icoUrl: "/static/images/ziyouren/default.ico",
      siderLogo: "/static/images/ziyouren/siderLogo.png",
      beianCode: '宁ICP备2021002090号'
    },
    'saas.guike800.com': {
      ename: "guike",
      title: "贵客800",
      domain: "saas.guike800.com", 
      logo: "/static/images/guike/logo.png",
      logoTop: "",
      logoLogin: "/static/images/guike/logo.png",
      backgroundImg: "/static/images/guike/banner.jpg",
      icoUrl: "/static/images/guike/default.ico",
      siderLogo: "/static/images/guike/siderLogo.png"
    },
    'khl-tmrl.51xinlong.com': {
      ename: "tengmai",
      title: "腾迈人力",
      domain: "khl-tmrl.51xinlong.com", 
      logo: "/static/images/tengmai/logo.png",
      logoTop: "",
      logoLogin: "/static/images/tengmai/logo.png",
      backgroundImg: "/static/images/tengmai/banner.jpg",
      icoUrl: "/static/images/tengmai/default.ico",
      siderLogo: "/static/images/tengmai/siderLogo.png"
    },
    'khl-lxt.51xinlong.com': {
      ename: "lingxintong",
      title: "灵薪通",
      domain: "khl-lxt.51xinlong.com", 
      logo: "/static/images/lingxintong/logo.png",
      logoTop: "",
      logoLogin: "/static/images/lingxintong/logo.png",
      backgroundImg: "/static/images/lingxintong/banner.jpg",
      icoUrl: "/static/images/lingxintong/default.ico",
      siderLogo: "/static/images/lingxintong/siderLogo.png"
    },
    'khl-hyg.51xinlong.com': {
      ename: "huiyonggong",
      title: "惠用工",
      domain: "khl-hyg.51xinlong.com", 
      logo: "/static/images/huiyonggong/logo.png",
      logoTop: "",
      logoLogin: "/static/images/huiyonggong/logo.png",
      backgroundImg: "/static/images/huiyonggong/banner.jpg",
      icoUrl: "/static/images/huiyonggong/default.ico",
      siderLogo: "/static/images/huiyonggong/siderLogo.png"
    },
    'khl-ygo.51xinlong.com': {
      ename: "youji",
      title: "优集go",
      domain: "khl-ygo.51xinlong.com", 
      logo: "/static/images/youji/logo.png",
      logoTop: "",
      logoLogin: "/static/images/youji/logo.png",
      backgroundImg: "/static/images/youji/banner.jpg",
      icoUrl: "/static/images/youji/default.ico",
      siderLogo: "/static/images/youji/siderLogo.png"
    },
    'khl-xyb.51xinlong.com': {
      ename: "xinyuanbao",
      title: "薪元宝",
      domain: "khl-xyb.51xinlong.com", 
      logo: "/static/images/xinyuanbao/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xinyuanbao/logo.png",
      backgroundImg: "/static/images/xinyuanbao/banner.jpg",
      icoUrl: "/static/images/xinyuanbao/default.ico",
      siderLogo: "/static/images/xinyuanbao/siderLogo.png"
    },
    'www.xinnengqifu.com': {
      ename: "xinnengqifu",
      title: "薪能科技",
      domain: "www.xinnengqifu.com", 
      logo: "/static/images/xinnengqifu/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xinnengqifu/logo.png",
      backgroundImg: "/static/images/xinnengqifu/banner.jpg",
      icoUrl: "/static/images/xinnengqifu/default.ico",
      siderLogo: "/static/images/xinnengqifu/siderLogo.png",
      beianCode: '黑ICP备2022001307号-1'
    },
    'khl-gsb.51xinlong.com': {
      ename: "gongshuibao",
      title: "工税宝",
      domain: "khl-gsb.51xinlong.com", 
      logo: "/static/images/gongshuibao/logo.png",
      logoTop: "",
      logoLogin: "/static/images/gongshuibao/logo.png",
      backgroundImg: "/static/images/gongshuibao/banner.jpg",
      icoUrl: "/static/images/gongshuibao/default.ico",
      siderLogo: "/static/images/gongshuibao/siderLogo.png"
    },
    'khl-zrzl.51xinlong.com': {
      ename: "zhongrunzhilian",
      title: "中润智联",
      domain: "khl-zrzl.51xinlong.com", 
      logo: "/static/images/zhongrunzhilian/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zhongrunzhilian/logo.png",
      backgroundImg: "/static/images/zhongrunzhilian/banner.jpg",
      icoUrl: "/static/images/zhongrunzhilian/default.ico",
      siderLogo: "/static/images/zhongrunzhilian/siderLogo.png"
    },
    'www.baisenyun.com': {
      ename: "baisen",
      title: "柏森数字云",
      domain: "www.baisenyun.com", 
      logo: "/static/images/baisen/logo.png",
      logoTop: "",
      logoLogin: "/static/images/baisen/logo.png",
      backgroundImg: "/static/images/baisen/banner.jpg",
      icoUrl: "/static/images/baisen/default.ico",
      siderLogo: "/static/images/baisen/siderLogo.png"
    },
    'khl-xinly.51xinlong.com': {
      ename: "xinliuyun",
      title: "薪流云",
      domain: "khl-xinly.51xinlong.com", 
      logo: "/static/images/xinliuyun/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xinliuyun/logo.png",
      backgroundImg: "/static/images/xinliuyun/banner.jpg",
      icoUrl: "/static/images/xinliuyun/default.ico",
      siderLogo: "/static/images/xinliuyun/siderLogo.png"
    },
    'khl-jyb.51xinlong.com': {
      ename: "jinyunbao",
      title: "金云宝",
      domain: "khl-jyb.51xinlong.com", 
      logo: "/static/images/jinyunbao/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jinyunbao/logo.png",
      backgroundImg: "/static/images/jinyunbao/banner.jpg",
      icoUrl: "/static/images/jinyunbao/default.ico",
      siderLogo: "/static/images/jinyunbao/siderLogo.png"
    },
    'saas.zbbxxkj.com': {
      ename: "zhongbaobao",
      title: "中保保",
      domain: "saas.zbbxxkj.com",
      logo: "/static/images/zhongbaobao/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zhongbaobao/logo.png",
      backgroundImg: "/static/images/zhongbaobao/banner.jpg",
      icoUrl: "/static/images/zhongbaobao/default.ico",
      siderLogo: "/static/images/zhongbaobao/siderLogo.png",
    },
    'khl-htsy.51xinlong.com': {
      ename: "gongxingpandian",
      title: "躬行盘点",
      domain: "khl-htsy.51xinlong.com",
      logo: "/static/images/gongxingpandian/logo.png",
      logoTop: "",
      logoLogin: "/static/images/gongxingpandian/logo.png",
      backgroundImg: "/static/images/gongxingpandian/banner.jpg",
      icoUrl: "/static/images/gongxingpandian/default.ico",
      siderLogo: "/static/images/gongxingpandian/siderLogo.png",
    },
    'khl-zxb.51xinlong.com': {
      ename: "zhongxiaobao",
      title: "众销宝",
      domain: "khl-zxb.51xinlong.com",
      logo: "/static/images/zhongxiaobao/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zhongxiaobao/logo.png",
      backgroundImg: "/static/images/zhongxiaobao/banner.jpg",
      icoUrl: "/static/images/zhongxiaobao/default.ico",
      siderLogo: "/static/images/zhongxiaobao/siderLogo.png",
    },
    'khl-hxd.51xinlong.com': {
      ename: "haixinda",
      title: "海新達",
      domain: "khl-hxd.51xinlong.com",
      logo: "/static/images/haixinda/logo.png",
      logoTop: "",
      logoLogin: "/static/images/haixinda/logo.png",
      backgroundImg: "/static/images/haixinda/banner.jpg",
      icoUrl: "/static/images/haixinda/default.ico",
      siderLogo: "/static/images/haixinda/siderLogo.png",
    },
    'khl-guc.51xinlong.com': {
      ename: "gucheng",
      title: "沽城",
      domain: "khl-guc.51xinlong.com",
      logo: "/static/images/gucheng/logo.png",
      logoTop: "",
      logoLogin: "/static/images/gucheng/logo.png",
      backgroundImg: "/static/images/gucheng/banner.jpg",
      icoUrl: "/static/images/gucheng/default.ico",
      siderLogo: "/static/images/gucheng/siderLogo.png",
    },
    'khl-all.51xinlong.com': {
      ename: "ailogo",
      title: "AILogo",
      domain: "khl-all.51xinlong.com",
      logo: "/static/images/ailogo/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ailogo/logo.png",
      backgroundImg: "/static/images/ailogo/banner.jpg",
      icoUrl: "/static/images/ailogo/default.ico",
      siderLogo: "/static/images/ailogo/siderLogo.png",
    },
    'www.juyongong.com.cn': {
      ename: "juyonggong",
      title: "聚用工",
      domain: "www.juyongong.com.cn",
      logo: "/static/images/juyonggongcom/logo.png",
      logoTop: "",
      logoLogin: "/static/images/juyonggongcom/logo.png",
      backgroundImg: "/static/images/juyonggongcom/banner.jpg",
      icoUrl: "/static/images/juyonggongcom/default.ico",
      siderLogo: "/static/images/juyonggongcom/siderLogo.png",
      beianCode: '赣公网安备36042702000145号  赣ICP备2022002115号'
    },
    'saas.yuxiaohr.com': {
      ename: "yuxiao",
      title: "禹霄",
      domain: "saas.yuxiaohr.com",
      logo: "/static/images/yuxiao/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yuxiao/logo.png",
      backgroundImg: "/static/images/yuxiao/banner.jpg",
      icoUrl: "/static/images/yuxiao/default.ico",
      siderLogo: "/static/images/yuxiao/siderLogo.png",
    },
    'khl-qhrl.51xinlong.com': {
      ename: "qiaohan",
      title: "桥涵人力",
      domain: "khl-qhrl.51xinlong.com",
      logo: "/static/images/qiaohan/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qiaohan/logo.png",
      backgroundImg: "/static/images/qiaohan/banner.jpg",
      icoUrl: "/static/images/qiaohan/default.ico",
      siderLogo: "/static/images/qiaohan/siderLogo.png",
    },
    'khl-qjl.51xinlong.com': {
      ename: "qijingling",
      title: "企晶灵",
      domain: "khl-qjl.51xinlong.com",
      logo: "/static/images/qijingling/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qijingling/logo.png",
      backgroundImg: "/static/images/qijingling/banner.jpg",
      icoUrl: "/static/images/qijingling/default.ico",
      siderLogo: "/static/images/qijingling/siderLogo.png",
    }
	}
}
let hostname = window.location.hostname
     //hostname = 'tradetest.51xinlong.com'
//同步请求
function sync_test(url, data) {
	//实例化XmlHttpRequest对象
	var xhr = new XMLHttpRequest();
	//使用GET方式请求指定网址的页面
	
	xhr.open("GET", process.env.VUE_APP_AXIOS_BASE_URL + url, false);
	xhr.setRequestHeader("DOMAIN",data);  //设置请求头
	//发送空内容请求
	xhr.send();

	if (xhr.status === 200) { //200状态码表示正常     
		return JSON.parse(xhr.responseText)?.data || ''
	} else {
		console.log(xhr.statusText)
	}
}
//获取oem
let res = sync_test('/oem/view', hostname)
let initData = {
    alipayAppId:'2000'
}
if (res.status || Object.keys(config.initDomain).includes(hostname)) {
	config.domain =res.data|| Object.assign(config.initDomain.default,config.initDomain[hostname])
} else {
	config.domain = config.initDomain.default
}
config.domain = {...initData, ...config.domain}
store.commit('handleDomainInfo', config.domain)

export default config
